import type { Page } from '../../types';

const minStandardLeadership: Page[] = [
  {
    pageType: 'question',
    title: 'Minimum Standards',
    name: 'minimum-standards',
    hidePageTitle: true,
    description:
      'A conversation must take place at the start of the year between you and your Line Manager to agree how these standards will be demonstrated in a way that is relevant to your role. You should agree how you will determine whether you have \'met\' these standards. The standards can be found here <a href="https://www.gov.uk/government/publications/senior-civil-service-performance-management" target="_blank" rel="noopener noreferrer">gov.uk</a>. Line Managers will make judgements on whether standards have been met as part of their validation.<br><br>Please complete the box below on how you have met each of the Minimum Standards. Please refer to evidence captured throughout the performance year<br><br>',
    questions: [
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Leadership',
        name: 'minimum-standard-leadership',
        detailsHeading: 'More information',
        detailsContent: `The minimum Leadership standards require all SCS to:<br><ul>
  <li>Budgetary responsibilities: type (e.g. admin/capital/programme), value and description (what is the budget for).</li>
  </ul>`,
        hint: `How will this be demonstrated in my role?  
  It is important that members of the SCS demonstrate, and evidence, positive leadership and management of people, enabling them to deliver consistently high quality outputs.  Manage the performance of your direct reports and the wider team, ensuring that poor performance is actively managed.  Taking responsibility for culture and provide a positive employee experience also identifying and addressing any barriers. Civil Service behaviours are set out in [Success Profiles](https://www.gov.uk/government/publications/success-profiles/success-profiles-civil-service-behaviours) and should be used in conjunction with [CO Leadership Commitments](https://intranet.cabinetoffice.gov.uk/about-the-cabinet-office/governance-and-leadership/new-leadership-commitments/).`,
        wordCount: 250,
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default minStandardLeadership;
